<template>
  <div>

    <loading-indicator
      v-if="isLoading"
    />

    <p v-if="message !== null">
      {{message}}
    </p>

    <table v-if="isDataLoaded && copies.length > 0" class="table text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Copy</th>
          <th scope="col">Time</th>
        </tr>
      </thead>
        <tr
          v-for="copy in copies"
          :key="copy.id"
        >
          <td>
            <player-resource-log-copy-link
              :playerId="playerId"
              :copyId="copy.id"
            />
          </td>
          <td>
            {{copy.ctime | getMomentStr}}
          </td>
        </tr>
    </table>

  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';
import PlayerResourceLogCopyLink from './PlayerResourceLogCopyLink.vue';

export default {
  name: 'PlayerResourceLogCopies',

  components: {
    LoadingIndicator,
    PlayerResourceLogCopyLink,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      isLoading: false,
      copies: null,
    };
  },

  computed: {
    isDataLoaded() {
      return this.copies !== null;
    },

    message() {
      if(this.copies !== null && this.copies.length === 0) {
        return 'No resource log copies.';
      }
      return null;
    },
  },

  created() {
    this.isLoading = true;

    const url = `/player/${this.playerId}/resource_log_copy_summaries`;
    HTTP.get(url)
    .then(response => {
      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.');
        return;
      }

      this.copies = [];
      for(var i = 0; i < data.length; ++i) {
        const copy = data[i];
        this.copies.push(copy);
      }
    })
    .catch(e => {
      notifier.showError(e.response.data);
    })
    .finally(() => {
      this.isLoading = false;
    });
  },
};
</script>
